var _path, _g, _path2, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIcPinDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 12,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.405 0C2.535 0 1.83.705 1.83 1.575v10.85c0 .87.705 1.575 1.575 1.575h7.62c.87 0 1.575-.705 1.575-1.575V4.471c0-.792-.585-1.447-1.346-1.558V1.575C11.254.705 10.549 0 9.679 0H3.405z",
    fill: "url(#a)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M1.399 0h11.2v14h-11.2z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 9,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.533.966a.724.724 0 0 0 0 1.448h6.619c0-.8-.649-1.448-1.449-1.448h-5.17zm3.863 3.258c-1.64 0-2.996 1.294-2.996 2.894 0 .806.297 1.555.787 2.19.535.7 1.2 1.31 1.954 1.788.188.119.343.11.514 0A7.742 7.742 0 0 0 9.61 9.307c.49-.634.787-1.383.787-2.19 0-1.6-1.356-2.893-3.001-2.893zm0 3.941c-.544 0-.988-.421-.988-.958 0-.531.444-.974.988-.974a.99.99 0 0 1 .992.974c0 .537-.448.958-.992.958z",
    fill: "url(#d)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M2.8.7h8.4v11.9H2.8z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1.83,
    y1: 0,
    x2: 1.83,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 1.399,
    y1: 0,
    x2: 1.399,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 2.809,
    y1: 0.966,
    x2: 2.809,
    y2: 11.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 2.8,
    y1: 0.7,
    x2: 2.8,
    y2: 12.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIcPinDark);
export default __webpack_public_path__ + "static/media/icon-ic-pin-dark.2b4a1ec049b23d3ed53eca624c77bf17.svg";
export { ForwardRef as ReactComponent };